export default __webpack_public_path__ + "static/media/background.2a92a954.jpg";